import { QueryClientProvider } from "@tanstack/react-query";
import { Outlet, useRouterState } from "@tanstack/react-router";
import { ThemeProvider } from "@/components/layout/ThemeProvider";
import { ErrorBoundary } from "@/components/shared/error-boundary";
import { RouteProgress } from "@/components/shared/route-progress";
import { Toaster } from "@/components/ui/sonner";
import { UploadQueueProvider } from "@/hooks/use-upload-queue";
import { queryClient } from "@/lib/query";

export function RootLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        {/* Photos keep uploading whichever page is open. */}
        <UploadQueueProvider>
          <RouteProgress />
          <ErrorBoundary resetKey={pathname}>
            <Outlet />
          </ErrorBoundary>
          <Toaster />
        </UploadQueueProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
